/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './../../core/BaseHttpRequest';
import type { OpenAPIConfig } from './../../core/OpenAPI';
import { AxiosHttpRequest } from './../../core/AxiosHttpRequest';
import { AssetsService } from './services/AssetsService';
import { CoinsService } from './services/CoinsService';
import { CustomerSettingsService } from './services/CustomerSettingsService';
import { DerivativesClosedPositionsService } from './services/DerivativesClosedPositionsService';
import { DerivativesCustomerConfigurationService } from './services/DerivativesCustomerConfigurationService';
import { DerivativesOpenedPositionsService } from './services/DerivativesOpenedPositionsService';
import { DerivativesOrdersService } from './services/DerivativesOrdersService';
import { DerivativesTradingPairsService } from './services/DerivativesTradingPairsService';
import { MaintenanceService } from './services/MaintenanceService';
import { OrderBookService } from './services/OrderBookService';
import { OtcTradingService } from './services/OtcTradingService';
import { ResourcesService } from './services/ResourcesService';
import { SpotTradingService } from './services/SpotTradingService';
import { StockTradingInstrumentsService } from './services/StockTradingInstrumentsService';
type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;
export class TradingGatewayApiClient {
    public readonly assets: AssetsService;
    public readonly coins: CoinsService;
    public readonly customerSettings: CustomerSettingsService;
    public readonly derivativesClosedPositions: DerivativesClosedPositionsService;
    public readonly derivativesCustomerConfiguration: DerivativesCustomerConfigurationService;
    public readonly derivativesOpenedPositions: DerivativesOpenedPositionsService;
    public readonly derivativesOrders: DerivativesOrdersService;
    public readonly derivativesTradingPairs: DerivativesTradingPairsService;
    public readonly maintenance: MaintenanceService;
    public readonly orderBook: OrderBookService;
    public readonly otcTrading: OtcTradingService;
    public readonly resources: ResourcesService;
    public readonly spotTrading: SpotTradingService;
    public readonly stockTradingInstruments: StockTradingInstrumentsService;
    public readonly request: BaseHttpRequest;
    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = AxiosHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? 'https://www.xbo-dev.space-app.io/trading-gateway',
            VERSION: config?.VERSION ?? '2.0.976.0',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });
        this.assets = new AssetsService(this.request);
        this.coins = new CoinsService(this.request);
        this.customerSettings = new CustomerSettingsService(this.request);
        this.derivativesClosedPositions = new DerivativesClosedPositionsService(this.request);
        this.derivativesCustomerConfiguration = new DerivativesCustomerConfigurationService(this.request);
        this.derivativesOpenedPositions = new DerivativesOpenedPositionsService(this.request);
        this.derivativesOrders = new DerivativesOrdersService(this.request);
        this.derivativesTradingPairs = new DerivativesTradingPairsService(this.request);
        this.maintenance = new MaintenanceService(this.request);
        this.orderBook = new OrderBookService(this.request);
        this.otcTrading = new OtcTradingService(this.request);
        this.resources = new ResourcesService(this.request);
        this.spotTrading = new SpotTradingService(this.request);
        this.stockTradingInstruments = new StockTradingInstrumentsService(this.request);
    }
}

